__turbopack_context__.v({
  "add_to_calendar": "styles-module-scss-module__zEyxQW__add_to_calendar",
  "alerts_container": "styles-module-scss-module__zEyxQW__alerts_container",
  "base_alert": "styles-module-scss-module__zEyxQW__base_alert",
  "base_alert_coming_soon": "styles-module-scss-module__zEyxQW__base_alert_coming_soon",
  "base_alert_listed_on": "styles-module-scss-module__zEyxQW__base_alert_listed_on",
  "base_alert_pending": "styles-module-scss-module__zEyxQW__base_alert_pending",
  "base_alert_price_change": "styles-module-scss-module__zEyxQW__base_alert_price_change",
  "is_desktop": "styles-module-scss-module__zEyxQW__is_desktop",
  "is_mobile": "styles-module-scss-module__zEyxQW__is_mobile",
  "tabs": "styles-module-scss-module__zEyxQW__tabs",
  "top_section": "styles-module-scss-module__zEyxQW__top_section",
  "virtual_tour": "styles-module-scss-module__zEyxQW__virtual_tour",
});
